import React, { useState } from 'react';
import map from 'lodash/map';
import OfferingBlock from './OfferingBlock';

import styles from './Offerings.module.css';

const offeringList = [
  {
    id: 1,
    title: 'Digital Underwriting',
    description: (
      <ul className={styles.offeringBlock_descriptionList}>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Internal or External Rating Engine
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Flexible system configuration allows for hosting of ratings or
            connecting to existing rating systems.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            3rd Party Data
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Rate calculations that leverage 3rd party data are seamless. Many
            leading data providers are already integrated into the SURE
            Platform.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Expedite Quote/Bind
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Allow for instant issue or underwriter approval based on specific
            rulesets.
          </p>
        </li>
      </ul>
    ),
  },
  {
    id: 2,
    title: 'INSTANT CLAIMS',
    description: (
      <ul className={styles.offeringBlock_descriptionList}>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Digital Claims
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            A fully customizable first notification of loss (FNOL) system that
            minimizes the need for human interaction and reduces call center
            costs.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Complex Workflows
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Conquer the most complex claims process with easy to use and
            pre-built claims capabilities.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Connect to Existing Vendors
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Stream claims and FNOLs to a TPA or in-house administration team.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Process Smarter
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Centralize the entire claims workflow in one system by seamlessly
            connecting the customer experience all the way to reimbursement.
          </p>
        </li>
      </ul>
    ),
  },
  {
    id: 3,
    title: 'CLOUD policy administration',
    description: (
      <ul className={styles.offeringBlock_descriptionList}>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Configure State & Region Specific Policies
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Complex code and weeks of development to launch new markets are
            eliminated.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Self Service Portals for Insured
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Gain a leg up on competition and enable the largest suite of
            self-service capabilities available for your policyholders.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Broker Portal
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Give your agents superpowers by enabling them to easily and quickly
            send proposals, issue policies, and offer bundles.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Go Global & Local
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Being part of the ever-changing insurance marketplace means being
            able to support every market. SURE has the only technology that
            services all 50 states and provides ongoing servicing customers now
            demand. We support multi-currency and multi-language for brands
            across the world.
          </p>
        </li>
      </ul>
    ),
  },
  {
    id: 4,
    title: 'OMNICHANNEL operations',
    description: (
      <ul className={styles.offeringBlock_descriptionList}>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Billing & Premium Collection
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Extend your existing capabilities with credit card, debit card, and
            ACH payments all secured and PCI Compliant.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Reporting
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Free your data from your existing platform. The SURE data model
            provides automated reports and real-time access to your data to make
            moves, when you need to.
          </p>
        </li>
        <li className={styles.offeringBlock_descriptionListItem}>
          <h2 className={styles.offeringBlock_descriptionHeadline}>
            Partner Success Team
          </h2>
          <p className={styles.offeringBlock_descriptionCopy}>
            Dedicated support resources just for you. These are builders that
            understand the ins-and-outs of insurance and are committed to the
            success of your program.
          </p>
        </li>
      </ul>
    ),
  },
];

const Offerings = () => {
  const [activeOfferingId, setActiveOffering] = useState(1);

  return (
    <div className={styles.offerings}>
      <div className={styles.offerings_container}>
        <h1 className={styles.offerings_title}>
          Execute & Grow Faster with SURE Platform.
        </h1>
        <p className={styles.offerings_description}>
          Launch new products or accelerate your current modernization plans
          without the need for additional IT resources.
        </p>
        <div className={styles.offerings_accordion}>
          {map(offeringList, offering => (
            <OfferingBlock
              key={offering.id}
              offering={offering}
              isOpen={offering.id === activeOfferingId}
              onToggle={() =>
                setActiveOffering(
                  activeOfferingId === offering.id ? null : offering.id
                )
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Offerings;
